import { render } from "./ProjectItemCard.vue?vue&type=template&id=b836c284"
import script from "./ProjectItemCard.vue?vue&type=script&lang=js"
export * from "./ProjectItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__